// src/libs/graphql-fetcher.ts

import type { RequestDocument } from "graphql-request";

import { ClientError, GraphQLClient } from "graphql-request";

const ALB_API_KEY = import.meta.env.VITE_ALB_API_KEY;
const ALB_API_VALUE = import.meta.env.VITE_ALB_API_VALUE;
const GRAPHQL_URL = `${import.meta.env.VITE_APP_API_BASE_URL}graphql`;

function getAccessToken(): string | null {
  return typeof window !== "undefined" ? localStorage.getItem("AccessToken") : null;
}

export const graphqlClient = new GraphQLClient(GRAPHQL_URL, {
  headers: (): Record<string, string> => {
    const token = getAccessToken();
    if (token === null) {
      return {
        Authorization: "Bearer ",
        [ALB_API_KEY]: ALB_API_VALUE,
      };
    }
    return {
      Authorization: `Bearer ${token}`,
      [ALB_API_KEY]: ALB_API_VALUE,
    };
  },
});

export function graphqlFetcher<TData, TVariables extends object = Record<string, unknown>>(
  query: RequestDocument | string,
  variables?: TVariables
): () => Promise<TData> {
  return async () => {
    // await ensureFreshToken();

    const token = getAccessToken();
    if (token === null) throw new Error("No access token available");

    try {
      const data = await graphqlClient.request<TData>(query, variables);
      return data;
    } catch (error) {
      if (error instanceof ClientError) {
        const message = error.response.errors?.[0]?.message ?? "GraphQL error";
        throw new Error(message);
      }
      throw error;
    }
  };
}
